import { TrendingDown, TrendingUp, Trophy } from "lucide-react";
import { Empty } from "../platform/athlete/shared";

export default function PersonalRecords({ records }) {
  if (!records || records.length === 0) return <Empty testid="academy-pr-empty">No personal records yet. They appear after your first test.</Empty>;
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="academy-pr-list">
      {records.map((r) => {
        const improved = r.improvement != null && r.improvement > 0;
        return (
          <div key={r.metric} data-testid={`academy-pr-${r.metric}`} className="bg-[#121212] border border-white/10 p-5">
            <div className="flex items-center justify-between mb-2">
              <p className="font-mono-accent text-[10px] tracking-[0.2em] uppercase text-white/40">{r.label}</p>
              <Trophy size={14} className="text-white/40" />
            </div>
            <p className="font-display font-black text-3xl tracking-tight">{r.current}<span className="text-base text-white/40 ml-1">{r.unit}</span></p>
            <div className="flex items-center justify-between mt-2 text-xs">
              <span className="text-white/40">Prev: {r.previous != null ? `${r.previous}${r.unit}` : "—"}</span>
              {r.improvement != null && r.improvement !== 0 && (
                <span className={`inline-flex items-center gap-1 ${improved ? "text-emerald-400" : "text-white/40"}`}>
                  {r.lower_is_better ? <TrendingDown size={12} /> : <TrendingUp size={12} />} {Math.abs(r.improvement)}{r.unit}
                </span>
              )}
            </div>
            {r.date && <p className="text-white/30 text-[11px] mt-1">{new Date(r.date).toLocaleDateString()}</p>}
          </div>
        );
      })}
    </div>
  );
}
